import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { CasinoMobileVersionState } from 'src/AppState/CmsState/CasinoMobileVersion/CasinoMobileVersionState';
import { CasinoMobileVersionModelType } from 'src/api/config/casinoMobileVersion/getCasinoMobileVersion';
import { ButtonOnInputSide } from 'src/domains/layouts/shared/buttons/Button.style';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { InputRow } from 'src/domains/layouts/shared/formComponents/input/Input.style';
import { ActionsWrapper, LabelWrapper, ListContainer, ListItem, ToggleWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { InputError } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { ColumnOneOfTwo, TwoColumnResponsiveContentReverse } from 'src/domains/layouts/shared/layout/Layout.style';
import { PageHeader, FormHeader } from '../AdminPage.styles';
import { MoreActions } from 'src/domains/layouts/shared/moreActions/MoreActions';

class State {
    constructor(
        private readonly casinoMobileVersionState: CasinoMobileVersionState,
        private readonly casinoVersion: CasinoMobileVersionModelType,
    ) { }

    setActiveFlag = async (): Promise<void> => {
        this.casinoMobileVersionState.setActiveFlag(this.casinoVersion.app_version);
    }

    handleRemoveApiCall = async (): Promise<void> => {
        await this.casinoMobileVersionState.handleRemoveApiCall(this.casinoVersion.app_version);
    }
}

interface PropsTypes {
    casinoMobileVersionState: CasinoMobileVersionState;
    casinoVersion: CasinoMobileVersionModelType;
}

const CasinoMobileVersionItem = observer(({ casinoMobileVersionState, casinoVersion }: PropsTypes) => {
    const [state] = useState(() => new State(casinoMobileVersionState, casinoVersion));

    return (
        <ListItem direction='row'>
            <LabelWrapper>{casinoVersion.app_version}</LabelWrapper>

            <ActionsWrapper>
                <ToggleWrapper label='Active' toggleActive={state.setActiveFlag} isActive={casinoVersion.is_casino_active} isDisabled={false} />
                <MoreActions onDelete={state.handleRemoveApiCall} />
            </ActionsWrapper>
        </ListItem>
    );
});


export const CasinoMobileVersion = observer(() => {
    const { cmsState: { casinoMobileVersionState } } = useAppStateContext();
    const {
        appVersion,
        casinoMobileVersionSortedList,
        handleCreate,
        errorMessageForList,
        isLoading
    } = casinoMobileVersionState;

    return (
        <TwoColumnResponsiveContentReverse>
            <ColumnOneOfTwo>
                <PageHeader>Make version active after it passes review</PageHeader>
                <ListContainer areLoading={isLoading}>
                    {casinoMobileVersionSortedList.map(casinoVersion => {
                        return (
                            <CasinoMobileVersionItem
                                key={casinoVersion.app_version}
                                casinoMobileVersionState={casinoMobileVersionState}
                                casinoVersion={casinoVersion}
                            />
                        );
                    })}
                </ListContainer>
            </ColumnOneOfTwo>

            <ColumnOneOfTwo>
                <FormHeader>Add app version</FormHeader>
                <InputRow>
                    <Input label='App version' formInputState={appVersion} />
                    <ButtonOnInputSide version='primary' size='regular' onClick={handleCreate}>Add</ButtonOnInputSide>
                </InputRow>
                {errorMessageForList === null ? null : <InputError>{errorMessageForList}</InputError>}
            </ColumnOneOfTwo>
        </TwoColumnResponsiveContentReverse>
    );
});
